import { render, staticRenderFns } from "./follwUpExam.vue?vue&type=template&id=835370e0"
import script from "./follwUpExam.vue?vue&type=script&lang=js"
export * from "./follwUpExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('835370e0')) {
      api.createRecord('835370e0', component.options)
    } else {
      api.reload('835370e0', component.options)
    }
    module.hot.accept("./follwUpExam.vue?vue&type=template&id=835370e0", function () {
      api.rerender('835370e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/fue/follwUpExam.vue"
export default component.exports